// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1W3WC","imageUploader":"EGiftCard_imageUploader__20I_S"};